var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("store::album::log_同步商品专辑"),
        "close-on-click-modal": false,
        visible: _vm.visible,
        width: "690px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        closed: _vm.close,
      },
    },
    [
      _c("p", { attrs: { slot: "title" }, slot: "title" }, [
        _vm._v(_vm._s(_vm.$t("store::album::log_同步商品专辑"))),
      ]),
      _c(
        "div",
        [
          _c(
            "div",
            { staticClass: "title" },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("store::album::log_选择店铺")) + "："),
              ]),
              _c(
                "el-select",
                {
                  staticStyle: { width: "280px", "margin-bottom": "16px" },
                  attrs: {
                    placeholder: _vm.$t("store::album::log_请选择店铺"),
                    disabled: !!_vm.defaultShopId,
                  },
                  on: { change: _vm.selectShop },
                  model: {
                    value: _vm.shopId,
                    callback: function ($$v) {
                      _vm.shopId = $$v
                    },
                    expression: "shopId",
                  },
                },
                _vm._l(_vm.shopList, function (item) {
                  return _c(
                    "el-option",
                    {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    },
                    [
                      _c("span", { staticStyle: { float: "left" } }, [
                        _vm._v(_vm._s(item.label)),
                      ]),
                      _c("el-badge", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: item.num,
                            expression: "item.num",
                          },
                        ],
                        staticClass: "select-badge",
                        attrs: { value: item.num, max: 99 },
                      }),
                    ],
                    1
                  )
                }),
                1
              ),
              _c("div", { staticStyle: { color: "#666" } }, [
                _vm._v(_vm._s(_vm.$t("store::album::log_同步tip"))),
              ]),
            ],
            1
          ),
          _c(
            "p",
            { staticStyle: { "font-weight": "bold", "margin-bottom": "24px" } },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("store::album::log_请选择需要同步的专辑")) +
                  " "
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "12px",
                    color: "#ff4d00",
                    "margin-left": "16px",
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-warning" }),
                  _vm._v(
                    " " + _vm._s(_vm.$t("store::album::log_同步title")) + " "
                  ),
                ]
              ),
            ]
          ),
          _c("z-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            ref: "table",
            attrs: {
              columns: _vm.columns,
              data: _vm.tableData,
              pagination: false,
              maxHeight: 300,
              customDefault: {
                height: "300px",
              },
            },
            on: { "selection-change": _vm.handleSelectTable },
            scopedSlots: _vm._u([
              {
                key: "no",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                },
              },
              {
                key: "title",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      { staticClass: "table-title" },
                      [
                        _c("ZImg", {
                          staticClass: "images",
                          attrs: { src: row.collectionImage },
                        }),
                        _c(
                          "span",
                          { staticStyle: { "margin-left": "16px", flex: "1" } },
                          [_vm._v(_vm._s(row.title))]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "status",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c("i", { class: "status-icon status" + row.status }),
                        _c("span", { staticStyle: { margin: "0 8px" } }, [
                          _vm._v(_vm._s(_vm.statusConfig[row.status])),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.cancel } },
            [_vm._v(" " + _vm._s(_vm.$t("system::common::btn::cancel")) + " ")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                size: "small",
                type: "primary",
                loading: _vm.sumbitLoading,
              },
              on: { click: _vm.sumbit },
            },
            [_vm._v(" " + _vm._s(_vm.$t("system::common::btn::confirm")) + " ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }